import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { Router, ActivatedRoute } from '@angular/router';
import { MASKS, NgBrazilValidators } from 'ng-brazil';
import { Auth } from 'src/app/models/auth';
import { ValidatePanResponse, BindRequest } from 'src/app/models/physical-card';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { EnderecoService } from 'src/app/services/endereco.service';
import { KycService } from 'src/app/services/kyc.service';
import { PhysicalCardService } from 'src/app/services/physical-card.service';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';
import { ApiError } from 'src/app/shared/enums/api-error.enum';
import { KycType } from 'src/app/shared/enums/kyc.enum';
import { GenericValidator } from 'src/app/shared/validators/generic-validator.validator';

@Component({
  selector: 'app-portador-vincular-cartao',
  templateUrl: './portador-vincular-cartao.component.html',
  styleUrls: ['./portador-vincular-cartao.component.scss']
})
export class PortadorVincularCartaoComponent implements OnInit {

    private currentUser: Auth;
    private cardholderGuid: any;

    cardDataFormGroup: FormGroup;

    public MASKS = MASKS;
    cardmask = [/\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ];
    datemask = [/\d/, /\d/, '/', /\d/, /\d/];

    validatedPanRes: ValidatePanResponse;
    isValidPan: boolean;
    showErrorPan: boolean = false;
    bindRequest: BindRequest;
    canBindNewUser: boolean;
    showErrorBindNewUser: boolean;
    bindcard: boolean = false;
    psCardId: string;


    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private _formBuilder: FormBuilder,
        private alertService: NewAlertService,
        private authenticationService: AuthenticationService,
        private addressService: EnderecoService,
        private kycService: KycService,
        private physicalCardService: PhysicalCardService,
    ) { }

    ngOnInit() {
        this.currentUser = this.authenticationService.currentUserValue;

        this.cardholderGuid = this.route.snapshot.params['id'];        

        this.createForm();
    }

    private createForm() {
        this.cardDataFormGroup = this._formBuilder.group({
            cardNumber: new FormControl(null, [
                Validators.required
            ]),
            cvv: new FormControl(null, [
                Validators.maxLength(3),
                Validators.required
            ]),
            expirationDate: new FormControl(null, [
                Validators.required
            ]),
            cardPin: new FormControl(null, [
                Validators.required,
                Validators.minLength(4),
                Validators.maxLength(4)
            ]),
            cardPinConfirm: new FormControl(null, [
                Validators.required,
                GenericValidator.mustMatch('cardPin')
            ])
        });

    }

    getPan(pan: string){
        if (this.cardDataFormGroup.get('cardNumber').valid && this.cardDataFormGroup.get('cardNumber').value !== null) {
            this.physicalCardService.validatePan(pan.replace(/\D+/g, '')).subscribe(
                response => {
                    this.validatedPanRes = response.result;

                    this.isValidPan = this.validatedPanRes.isValidPan;
                    this.showErrorPan = !this.isValidPan;
                    this.canBindNewUser = this.validatedPanRes.canBindNewUser;
                    this.showErrorBindNewUser = !this.canBindNewUser;
                    this.bindcard = this.isValidPan;

                    this.psCardId = this.validatedPanRes.psCardId;
                }, error => {
                    this.alertService.error('Cartão não encontrado!');
                }
            );
        }
    }

    bindCard(){
        if(this.cardDataFormGroup.valid){

            this.bindRequest = new BindRequest;
            this.bindRequest.assignorGuid = this.currentUser.token.assignorGuid;
            this.bindRequest.managerGuid = this.currentUser.token.userReferenceId;
            this.bindRequest.cardholderGuid = this.cardholderGuid;
            this.bindRequest.psCardId = this.psCardId;
            this.bindRequest.pan = this.cardDataFormGroup.get('cardNumber').value.replace(/\D+/g, '');
            this.bindRequest.cvv = this.cardDataFormGroup.get('cvv').value;
            this.bindRequest.validityDate = this.cardDataFormGroup.get('expirationDate').value;
            this.bindRequest.cardPin = this.cardDataFormGroup.get('cardPin').value;
            this.bindRequest.cardPinConfirm = this.cardDataFormGroup.get('cardPinConfirm').value;

            this.physicalCardService.bindCardLegalPerson(this.bindRequest).subscribe(
                response => {
                    if(response.status == ApiError.Sucesso){
                        this.redirectList()
                    }
                    else{
                        this.alertService.error(response.message);
                    }
                }
            )
        }
    }

    redirectList(){
        this.router.navigate(['list'], { relativeTo: this.route.parent });
    }
}
